let routes = {
  AudienceHistory: 'import-history',
  senderDomain: 'senders-domain',
  senderSMS: 'senders-sms',
  campaignList: 'campaignList',
}

const selectRouteName = routeCode => {
  return routes[routeCode]
}

export default selectRouteName
